import { render, staticRenderFns } from "./generalAnalysis.vue?vue&type=template&id=5ef66b56&scoped=true&"
import script from "./generalAnalysis.vue?vue&type=script&lang=js&"
export * from "./generalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./generalAnalysis.vue?vue&type=style&index=0&id=5ef66b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef66b56",
  null
  
)

export default component.exports